import { Grid } from "@mui/material";
import React from "react";
import { capitalizeFirstLetter } from "../../../../../constants";
import QTDetailsTextFieldWithLabelSection from "../../../../../common/QTDetailsTextFieldWithLabelSection";
import { useAuth } from "../../../../../hooks";

const ReportActionDataFieldsSection = ({
  reportDetails,
  setReportDetails,
  editEnabled,
}) => {
  const { currentUser } = useAuth();
  return (
    <Grid container style={dataContainerStyles}>
      {/*left side column*/}
      <Grid item container direction={"column"} xs>
        {/*qt Status section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Status"}
          value={
            reportDetails?.status?.status
            // capitalizeFirstLetter(reportDetails?.status?.status)
          }
          disabled={true}
          editEnabled={editEnabled}
          select={true}
          dropdownValues={["reported", "in review", "resolved"]}
          onChange={(e) => {
            setReportDetails({
              ...reportDetails,
              status: {
                ...reportDetails.status,
                status: e.target.value,
                date: new Date(),
                updatedById: currentUser?.id,
                updatedBy: currentUser?.userName,
              },
            });
          }}
        />
        {/*Action section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Action"}
          value={
            reportDetails?.status?.action &&
            capitalizeFirstLetter(reportDetails?.status?.action)
          }
          disabled={true}
          editEnabled={editEnabled}
          select={true}
          dropdownValues={[
            "No Action",
            reportDetails.type === "organization"
              ? "Org Warned"
              : "User Warned",
            "Content Removed",
            reportDetails.type === "organization"
              ? "Org Warned"
              : "User Suspended",
          ]}
          // dropdownValues={[
          //   "Resolved - No Action",
          //   "Resolved - User Warned",
          //   "Resolved - Content Removed",
          //   "Resolved - User Suspended",
          // ]}
          onChange={(e) =>
            setReportDetails({
              ...reportDetails,
              status: {
                ...reportDetails.status,
                action: e.target.value,
                date: new Date(),
                updatedById: currentUser?.id,
                updatedBy: currentUser?.userName,
              },
              // statusHistory: temp,
            })
          }
        />
      </Grid>
      {/*right side column*/}
      <Grid item container direction={"column"} xs>
        {/*Notes section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Notes"}
          value={reportDetails?.status?.notes}
          disabled={true}
          multiline={true}
          rows={5}
          editEnabled={editEnabled}
          onChange={(e) =>
            setReportDetails({
              ...reportDetails,
              status: {
                ...reportDetails.status,
                notes: e.target.value,
                date: new Date(),
                updatedById: currentUser?.id,
                updatedBy: currentUser?.userName,
              },
            })
          }
        />
      </Grid>
    </Grid>
  );
};

export default ReportActionDataFieldsSection;

const dataContainerStyles = {
  borderRadius: 12,
  boxShadow: " 0px 0px 30px 0px rgba(80, 85, 136, 0.15)",
  background: "var(--gray-99, #FCFCFC)",
  padding: "36px 15px",
  marginTop: 30,
};
